module.exports = __webpack_public_path__ + "media/images/online/online-main-image-7f0bb667a61200c3b7cfd4b73e05e89a.png";